<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  <div class="text-center mb-4">
    <h3 *ngIf="authConfig?.loginHeaderName" [innerHTML]="authConfig?.loginHeaderName"></h3>

    <!-- subheader -->
    <ng-container *ngIf="authConfig?.loginCustomHtml; then customSubheader; else subHeader"></ng-container>
    <ng-template #customSubheader>
      <p [innerHtml]="authConfig?.loginCustomHtml"></p>
    </ng-template>
    <ng-template #subHeader>
      <p class="text-muted mb-2" *ngIf="authConfig?.loginSubHeader">
        {{ authConfig?.loginSubHeader }}
      </p>
      <p
        class="f-size-xs mb-2"
        *ngIf="authConfig?.loginContactName && authConfig?.loginContactEmail"
        [innerHTML]="
          t('contactInstructions', {
            name: authConfig?.loginContactName,
            email: authConfig?.loginContactEmail
          })
        "
      ></p>
    </ng-template>
  </div>
</ng-container>
